<template>
	<div class="event">
		<div class="event__left">
			<span class="event__date" v-if="eventDate">{{
				moment(eventData.datetime_start).format('ddd D')
			}}</span>
		</div>
		<div class="event__right">
			<div class="event__right__left">
				<h3 class="event__title">
					<a :href="eventUrl(eventData)">{{ eventData.name }}</a>
				</h3>
				<p class="event__venue">{{ eventData.location.name }}</p>
			</div>
			<div class="event__right__right">
				<span class="event__time">{{
					moment(eventData.datetime_start).format('h:mma')
				}}</span>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

Vue.prototype.moment = moment;

export default {
	name: 'Event',
	props: ['eventData'],
	data() {
		return {
			eventDate: ''
		};
	},
	created() {
		this.dateCheck(this.eventData.eventDay);
	},
	methods: {
		eventUrl(post) {
			const title = encodeURIComponent(post.name).toLowerCase();
			const startDate = moment(post.datetime_start).format('YYYY-MM-DD');
			const endDate = moment(post.datetime_end).format('YYYY-MM-DD');
			const identifier = post.identifier;
			const url =
				'/nlfchurch/event/?title=' +
				title +
				'&date_start=' +
				startDate +
				'&date_end=' +
				endDate +
				'&identifier=' +
				identifier +
				'';
			return url;
		},
		dateCheck(eventDate) {
			if (eventDate === null) {
				this.eventDate = false;
			} else {
				this.eventDate = true;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.event {
	display: flex;
}

.event__left {
	min-width: 160px;
	flex-basis: 160px;
	padding: 5px 0 0;
}

.event__date {
	font-size: 36px;
	color: $purple;
	font-weight: $bold;
}

.event__right {
	flex-grow: 1;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	border-left: 5px solid #eaebf2;
	padding: 10px 0 10px 40px;
}

.event__right__left {
	padding: 0 20px 0 0;
}

.event__title {
	font-size: 22px;
	font-weight: $bold;
	margin: 0 0 5px;

	a {
		color: $blue;
		transition: 0.2s;
		text-decoration: none;

		&:hover {
			color: $teal;
		}
	}
}

.event__venue {
	color: #aeb0c8;
	margin: 0;
	font-weight: $medium;
}

.event__time {
	font-size: 22px;
	font-weight: $bold;
	opacity: 0.5;
	color: $blue;
}

@media screen and (max-width: 600px) {
	.event {
		flex-direction: column;
		margin: 0 0 20px;
		padding: 0 0 25px;
		border-bottom: 5px solid #eaebf2;
	}

	.event__left {
		flex-basis: auto;
	}

	.event__right {
		border: none;
		padding: 0;
		flex-direction: column-reverse;
	}

	.event__time {
		display: block;
		margin: 0 0 5px;
	}
}
</style>
